import { generateMarketPathname } from '@chewy/market-handler';
import { useQuery } from '@tanstack/react-query';

import { AnalyticsUserContext } from '@/providers/types';
import { getAuthenticatedAxios } from '@/services/network/authenticated-axios';
import { getAssetPrefix } from '@/utils/marketHandler';

const userContextURL = '/app/rest/user-context';
const USER_CONTEXT_QUERY_KEY = userContextURL;

/**
 * This hook is used to fetch the user context on the client side
 * @param shouldFetch should only be true when you want the service call to be executed
 * @returns
 */
export const useUserContext = (market: string, shouldFetch = true) => {
  const fetcher = () => {
    const authenticatedAxios = getAuthenticatedAxios();

    if (!authenticatedAxios) {
      throw new Error('Authenticated user context can only be fetched in the browser.');
    }

    return authenticatedAxios
      .get<AnalyticsUserContext>(`${generateMarketPathname(userContextURL, market)}`, {
        withCredentials: true,
      })
      .then(({ data }) => data?.userContextData);
  };

  return useQuery({
    queryKey: [`${generateMarketPathname(USER_CONTEXT_QUERY_KEY, market)}`],
    queryFn: fetcher,
    enabled: shouldFetch,
  });
};

useUserContext.key = `${getAssetPrefix(USER_CONTEXT_QUERY_KEY)}`;
